export * from './surveys.config'
